import React from 'react';
import { NodeViewProps } from '@tiptap/core';
import { NodeViewWrapper } from '@tiptap/react';
import RenderVideoFile from '../renderVideoFile';
import { SnapEmbedAttributesInterface } from '../../interfaces/tiptapInterface';
import createEmbed from './createEmbed';

export interface SnapEmbedOptions {
  HTMLAttributes?: SnapEmbedAttributesInterface;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    snapEmbed: {
      setSnapEmbed: (options: {
        url: string;
        id: string | undefined;
        recordingName: string;
        themeMode?: string;
        nodeId?: string;
      }) => ReturnType;
    };
  }
}

// React NodeView Component using RenderVideoFile
const SnapEmbedComponent: React.FC<NodeViewProps> = ({ node }) => {
  const { url, id, recordingName } = node.attrs;

  return (
    <NodeViewWrapper className='snap-embed-wrapper'>
      <RenderVideoFile videoId={id} videoName={recordingName} videoUrl={url} isYouTubePreview={false} />
    </NodeViewWrapper>
  );
};

export const SnapEmbed = createEmbed({
  name: 'snapEmbed',
  tag: 'div.screen-recording-custom-main-div',
  component: SnapEmbedComponent,
  draggable: true,
  attributes: {
    url: { default: null },
    id: { default: '' },
    recordingName: { default: '' },
    themeMode: { default: 'light' },
    nodeId: { default: '' }
  },
  parseHTMLGetAttrs: (dom: HTMLElement) => ({
    url: dom.getAttribute('url'),
    id: dom.getAttribute('id'),
    recordingName: dom.getAttribute('name'),
    themeMode: dom.getAttribute('data-theme-mode')
  }),
  renderHTMLAttributes: (HTMLAttributes) => {
    return {
      class: 'screen-recording-custom-main-div',
      url: HTMLAttributes?.url,
      name: HTMLAttributes.recordingName,
      id: HTMLAttributes.id
    };
  }
});
